import { useBaseListView } from '@/common/view/useBaseListView';
import { useCrudActions } from '@/common/view/useCrudActions';
import { avatarService } from '@/services/avatar';
import { computed } from 'vue';

export function useAvatarLayerList() {
    const { list, total, fetchList } = useBaseListView({ request: avatarService.layer.list });

    const layerOption = computed(() => list.value.map(l => ({ label: l.name, value: l.id })));
    const layerMap = computed(() => new Map(list.value.map(l => [l.id, l])));

    const actions = {
        remove: useCrudActions().confirmAndRemove({
            request: avatarService.layer.remove,
            onSuccess: () => fetchList()
        })
    };

    return { list, total, fetchList, actions, layerOption, layerMap };
}
